import { render, staticRenderFns } from "./DockingIcon.vue?vue&type=template&id=bf36005c"
import script from "./DockingIcon.vue?vue&type=script&lang=js"
export * from "./DockingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports